import { useTranslation } from "react-i18next";
import {
    FrontendUserInfo,
    OrganizationInfo,
} from "node-library/dist/portal";
import { NeutralColor } from "node-library/dist/colors";
import ViewOrganizationsTable from "./viewOrganizationTable";

interface Props {
    organizations: Array<OrganizationInfo>;
    user: FrontendUserInfo | undefined;
    deleteOrganization: (organization: OrganizationInfo) => void;
    goToViewOrganizationDetails: (organization: OrganizationInfo) => void;
    goToEditOrganizationPage: (organization: OrganizationInfo) => void;
    setDiscardOrganizationConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
    setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function OrganizationContent(props: Props) {
    const { t: translation } = useTranslation();

    const {
        organizations,
        goToViewOrganizationDetails,
        setDiscardOrganizationConfirmOpen,
        setProceedAction,
        deleteOrganization,
        goToEditOrganizationPage,
    } = props;

    return (
        <div style={{ flex: "1 1 0%", position: "relative" }}>
            {organizations.length === 0 ? (
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        position: "absolute",
                        left: "50%",
                        top: "50%",
                        transform: "translate(-50%, -50%)",
                        gap: "5px",
                    }}
                >
                    <div
                        className="typography-heading-01"
                        style={{ marginTop: "20px", color: NeutralColor.NEUTRAL_GREY_300 }}
                    >
                        {translation("NoOrganizations")}
                    </div>
                </div>
            ) : (
                <div>
                    <ViewOrganizationsTable
                        organizations={organizations}
                        user={props.user}
                        goToViewOrganizationDetails={goToViewOrganizationDetails}
                        setDiscardOrganizationConfirmOpen={setDiscardOrganizationConfirmOpen}
                        deleteOrganization={deleteOrganization}
                        setProceedAction={setProceedAction}
                        goToEditOrganizationPage={goToEditOrganizationPage}
                    />
                </div>
            )}
        </div>
    );
}
